import axiosClient from "../axiosClient";

export const configDefault = {
    getStream: () => {
        return axiosClient.get('/cameraManagement/get-stream-mode-default/')
    },
    // post: (data) => {
    //     return axiosClient.post('/company/post-add-company/', data)
    // },
    putStream: (data) => {
        return axiosClient.put(`/cameraManagement/put-change-stream-mode-default/`, data)
    },
    getAllConfig: () => {
        return axiosClient.get('/cameraManagement/get-system-default-config/')
    },
    putChangeAllConfig: (data) => {
        return axiosClient.put(`/cameraManagement/put-change-system-default-config/`, data)
    },
    putChangeSystemDefaultConfig: (data, mode) => {
        return axiosClient.put('/cameraManagement/put-change-system-default-config/', {
            list_items: data,
            mode: mode ? mode : null
        })
    },
    postVerifyUpdate: (data) => {
        return axiosClient.post("/cameraManagement/post-verify-update-system-default/", data)
    }
}